module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mainProduct__header"
  }, [_vm._v("\n  " + _vm._s(_vm.pathHeader) + "\n  "), _c('span', {
    staticClass: "mainProduct__headerTail"
  }, [_vm._v("\n    " + _vm._s(_vm.pathTail) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73810a09","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainHeader.vue
// module id = 57
// module chunks = 0